module.exports = __webpack_public_path__ + "img/background038.52a5f7e4.jpg";